import { motion } from "framer-motion";
// import { useState } from 'react';
import React, { useState, useEffect, useRef, useMemo } from "react";
import LeakRate from "../components/LeakRate";
import WaterRates from "../components/WaterRates";
import {
  Pencil,
  Trash2,
  Plus,
  Settings,
  Users,
  Building2,
  Gauge,
  History,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Info,
  DollarSign,
  ArrowDown,
  ArrowUpDown,
  ArrowUp,
  Droplet 
} from "lucide-react";
import {
  createSettingsParameters,
  deleteAdminSetting,
  editAdminSetting,
  getAdminSettingsList,
  getMeterManagement,
  getOverrideAccountsList,
  getUserList,
  signupUser,
  editUser,
  resetUserPassword,
  getChangeLog,
  getEntityChangeLog,
  deleteUser,
  editOverrideName,
} from "../services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfoTooltip from "../components/ui/InfoTooltip";
import { useTheme } from "../context/ThemeContext";
import { useDistrict } from "../utils/DistrictContext";
import { post, get } from "../Libraries/Ajax/HttpService";
import { Spin } from "antd";

export function Listuser({ onBack }) {
  // accountname edit
  const [showEditUserNameModal, setShowEditUserNameModal] = useState(false);
  const [editUserName, setEditUserName] = useState("");
  const [editOverrideId, setEditOverrideId] = useState(null);
  // accountname edit end
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  // --- 2. USERS PAGINATION ---
  const [userPage, setUserPage] = useState(1);
  const [userPageSize, setUserPageSize] = useState(10);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [users, setUsers] = useState([]); // State to hold the list of users
  const { selectedDistrict } = useDistrict();
  const [userSort, setUserSort] = useState({
    key: null,
    direction: "asc",
  });
  const sortedUsers = useMemo(() => {
    let data = [...users];

    if (userSort.key) {
      data.sort((a, b) => {
        const aValue = a[userSort.key];
        const bValue = b[userSort.key];

        return userSort.direction === "asc"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      });
    }

    return data;
  }, [users, userSort]);
  const userTotalPages = Math.ceil(sortedUsers.length / userPageSize);
  const paginatedUsers = sortedUsers.slice(
    (userPage - 1) * userPageSize,
    userPage * userPageSize,
  );
  const [accPage, setAccPage] = useState(1);
  const [accPageSize, setAccPageSize] = useState(10);
  // --- Users Pagination Logic ---
  const userDisplayCount = sortedUsers.length;

  const userStartIndex = (userPage - 1) * userPageSize;

  const [accounts, setAccounts] = useState([]);
  const [accountSort, setAccountSort] = useState({
    key: null,
    direction: "asc",
  });
  const [newUserPasswordScore, setNewUserPasswordScore] = useState(0);

  // --- Accounts Pagination Logic ---
  const sortedAccounts = useMemo(() => {
    let data = [...accounts];

    if (accountSort.key) {
      data.sort((a, b) => {
        const aValue = a[accountSort.key];
        const bValue = b[accountSort.key];

        return accountSort.direction === "asc"
          ? String(aValue || "").localeCompare(String(bValue || ""))
          : String(bValue || "").localeCompare(String(aValue || ""));
      });
    }

    return data;
  }, [accounts, accountSort]);
  const accDisplayCount = sortedAccounts.length;
  const accTotalPages = Math.ceil(accDisplayCount / accPageSize);
  const accStartIndex = (accPage - 1) * accPageSize;

  // Create the sliced data for the table
  const paginatedAccounts = useMemo(
    () => sortedAccounts.slice(accStartIndex, accStartIndex + accPageSize),
    [sortedAccounts, accStartIndex, accPageSize],
  );

  const [parameters, setParameters] = useState([]);
  const [editUserData, setEditUserData] = useState({});
  const [editUserId, setEditUserId] = useState(null);
  const loggedUser = JSON.parse(localStorage.getItem("MCData"));
  const userDistricts = loggedUser?.district || [];
  const hasOverrideEditPermission = loggedUser?.permission?.some(
    (p) => p.permissions === "accounts_overide_edit" && p.is_true === true,
  );
  const userType = loggedUser?.type; // "U", "A", "SA"
  const userTypeOptions = useMemo(() => {
    if (userType === "SA") {
      return [
        { label: "Super Admin", value: "SA" },
        { label: "Admin", value: "A" },
        { label: "User", value: "U" },
      ];
    }

    if (userType === "A") {
      return [
        { label: "Admin", value: "A" },
        { label: "User", value: "U" },
      ];
    }

    // Optional: for normal user
    return [{ label: "User", value: "U" }];
  }, [userType]);

  const { theme, colors } = useTheme();
  // --- 1. SETTINGS / PARAMETERS PAGINATION ---
  const [paramPage, setParamPage] = useState(1);
  const [paramPageSize, setParamPageSize] = useState(10);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const sortedParameters = useMemo(() => {
    let data = [...parameters];

    if (sortConfig.key) {
      data.sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        if (typeof aValue === "number" && typeof bValue === "number") {
          return sortConfig.direction === "asc"
            ? aValue - bValue
            : bValue - aValue;
        }

        return sortConfig.direction === "asc"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      });
    }

    return data;
  }, [parameters, sortConfig]);
  const paramTotalPages = Math.ceil(sortedParameters.length / paramPageSize);
  const paginatedParameters = sortedParameters.slice(
    (paramPage - 1) * paramPageSize,
    paramPage * paramPageSize,
  );

  // --- 3. ACCOUNTS PAGINATION ---

  // Auto-reset to page 1 when sorting or district changes
  useEffect(() => {
    setUserPage(1);
    setParamPage(1);
    setAccPage(1);
  }, [selectedDistrict, userSort, sortConfig, accountSort]);
  const [passwordData, setPasswordData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [confirmFeedback, setConfirmFeedback] = useState("");
  const [passwordScore, setPasswordScore] = useState(0);

  const calculatePasswordStrength = (password) => {
    let score = 0;

    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;
    if (!/\s/.test(password)) score++;

    return score;
  };

  const [activeTab, setActiveTab] = useState("settings");
  const [showAddParameterModal, setShowAddParameterModal] = useState(false);
  const [showUserRegistrationModal, setShowUserRegistrationModal] =
    useState(false);
  const [newParameter, setNewParameter] = useState({
    name: "",
    value: "",
    unit: "",
    displayName: "",
    status: true,
  });
  const [newUser, setNewUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    userType: "",
    districts: [],
  });

  const [loading, setLoading] = useState(false);

  const [userErrors, setUserErrors] = useState({});
  const [editUserErrors, setEditUserErrors] = useState({});
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 9 }, (_, i) => currentYear - i);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);
  const now = new Date();
  const previousMonthIndex = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [selectedMonth, setSelectedMonth] = useState(
    months[previousMonthIndex],
  );

  // upload

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.endsWith(".xlsx")) {
      alert("Please upload a valid XLSX file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("year", 2026);
    formData.append("month", 2);
    try {
      setUploading(true);

      const response = await post("apis/upload_flow", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response) {
        toast.success("File uploaded successfully!");
        if (fileInputRef.current) fileInputRef.current.value = "";
      } else {
        throw new Error("Empty response from server");
      }
    } catch (error) {
      console.error("Upload Error:", error);

      const errorMsg =
        error.response?.data?.message || "Upload failed. Please try again.";
      toast.error(errorMsg);
    } finally {
      setUploading(false);
    }
  };

  // register user
  const handleUserSignup = async () => {
    const errors = {};
    const email = newUser.email?.trim();

    if (!newUser.firstName.trim()) errors.firstName = "First name is required";

    if (!newUser.lastName.trim()) errors.lastName = "Last name is required";

    if (!email) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = "Enter a valid email address";
    }

    if (!newUser.password.trim()) {
      errors.password = "Password is required";
    } else if (newUserPasswordScore < 4) {
      errors.password = "Password is too weak";
    }

    if (!newUser.userType) errors.userType = "User type is required";

    if (!newUser.districts.length)
      errors.districts = "Select at least one district";

    if (Object.keys(errors).length > 0) {
      setUserErrors(errors);
      return;
    }

    try {
      const payload = {
        first_name: newUser.firstName,
        last_name: newUser.lastName,
        email: newUser.email,
        password: newUser.password,
        user_type: newUser.userType,
        districts: newUser.districts.join(","),
      };

      await signupUser(payload);

      setUserErrors({});
      setShowUserRegistrationModal(false);
      fetchUserList();
      resetUserForm();
    } catch (error) {
      setUserErrors({
        apiError: error.response?.data?.message || "Signup failed",
      });
    }
  };
  const resetUserForm = () => {
    setNewUser({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      userType: "",
      districts: [],
    });
  };

  // end register user
  useEffect(() => {
    if (!showUserRegistrationModal) {
      setUserErrors({});
    }
  }, [showUserRegistrationModal]);

  useEffect(() => {
    if (!showEditUserModal) {
      setEditUserErrors({});
    }
  }, [showEditUserModal]);
  // edit user
  const handleUserEdit = async () => {
    const errors = {};
    const email = editUserData.email?.trim();

    if (!editUserData.firstName?.trim())
      errors.firstName = "First name is required";

    if (!editUserData.lastName?.trim())
      errors.lastName = "Last name is required";

    if (!email) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = "Enter a valid email address";
    }

    if (!editUserData.userType) errors.userType = "User type is required";

    if (!editUserData.districts?.length)
      errors.districts = "Select at least one district";

    if (Object.keys(errors).length > 0) {
      setEditUserErrors(errors);
      return;
    }

    try {
      const payload = {
        first_name: editUserData.firstName.trim(),
        last_name: editUserData.lastName.trim(),
        email: editUserData.email.trim(),
        user_type: editUserData.userType,
        active: editUserData.isActive ? 1 : 0,
        districts: editUserData.districts.join(","),
      };

      await editUser(editUserId, payload);

      setEditUserErrors({});
      setShowEditUserModal(false);
      fetchUserList();
    } catch (error) {
      setEditUserErrors({
        apiError: error.response?.data?.message || "Update failed",
      });
    }
  };
  // end edit user
  // delete user
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);

  const confirmUserDelete = async () => {
    try {
      if (!deleteUserId) {
        toast.error("Invalid user ID");
        return;
      }

      await deleteUser(deleteUserId);

      toast.success("User deleted successfully");

      setUsers((prev) => prev.filter((u) => u.id !== deleteUserId));

      setShowDeleteUserModal(false);
      setDeleteUserId(null);
    } catch (error) {
      console.error("Delete failed:", error.response?.data || error);
      toast.error("Delete failed ❌");
    }
  };
  //  delete user ends

  // password reset
  const handlePasswordChange = (e) => {
    const value = e.target.value;

    const score = calculatePasswordStrength(value);
    setPasswordScore(score);

    setPasswordData((prev) => ({
      ...prev,
      newPassword: value,
    }));

    if (
      passwordData.confirmPassword &&
      value !== passwordData.confirmPassword
    ) {
      setConfirmFeedback("Password is not matching.");
    } else {
      setConfirmFeedback("");
    }
  };
  const handleConfirmChange = (e) => {
    const value = e.target.value;

    setPasswordData((prev) => ({
      ...prev,
      confirmPassword: value,
    }));

    if (value !== passwordData.newPassword) {
      setConfirmFeedback("Password is not matching.");
    } else {
      setConfirmFeedback("");
    }
  };

  const handlePasswordReset = async () => {
    try {
      if (passwordScore < 4) {
        toast.error("Password is too weak");
        return;
      }

      if (passwordData.newPassword !== passwordData.confirmPassword) {
        toast.error("Passwords do not match");
        return;
      }

      const payload = {
        new_password: passwordData.newPassword,
        confirm_password: passwordData.confirmPassword,
        email: editUserData.email, //  IMPORTANT
      };

      console.log("RESET PAYLOAD:", payload);

      await resetUserPassword(payload);

      toast.success("Password updated successfully");
      setShowPasswordModal(false);

      setPasswordData({
        newPassword: "",
        confirmPassword: "",
      });

      setConfirmFeedback("");
    } catch (error) {
      toast.error(error.response?.data?.message || "Password reset failed");
    }
  };

  // end password reset

  useEffect(() => {
    const fetchAdminSettings = async () => {
      try {
        setLoading(true); // Start loading
        const res = await getAdminSettingsList(); // Fetch data from API
        console.log("API Response:", res); // Log the full response to inspect it

        // If response contains a 'data' key, map over res.data instead of res
        const formattedParameters = res.data.map((param) => ({
          id: param.id,
          name: param.field_name,
          value: param.value,
          unit: param.unit,
          displayName: param.display_name || "",
          status: param.active ? "Active" : "Inactive",
        }));

        setParameters(formattedParameters); // Set the state with formatted data
      } catch (err) {
        console.error("Admin settings fetch failed:", err);
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchAdminSettings();
  }, [selectedDistrict]);

  const [userLoading, setUserLoading] = useState(true); // Loading state

  const fetchUserList = async () => {
    try {
      setUserLoading(true); // Start loading before fetching data
      const response = await getUserList(); // Get data from API
      console.log("Fetched User List:", response.data.Users); // Check the structure of the fetched data
      setUsers(response.data.Users); // Set the users state with the fetched data
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setUserLoading(false); // Stop loading after the request
    }
  };

  useEffect(() => {
    fetchUserList(); // Fetch user list when component mounts
  }, [selectedDistrict]); // Empty dependency array to fetch data only on mount

  const [accountsLoading, setAccountsLoading] = useState(false);
  // Fetch accounts only if district is available
  const fetchAccounts = async () => {
    try {
      setAccountsLoading(true);
      const response = await getOverrideAccountsList(); // No district passed
      setAccounts(response.data.account_override_list || []);
    } catch (error) {
      console.error("Failed to fetch accounts:", error);
    } finally {
      setAccountsLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
    fetchMeterData();
  }, [selectedDistrict]);

  const [meterloading, setMeterLoading] = useState(false); // Controls loading state specifically for meter data
  const [meters, setMeters] = useState([]); // Stores the fetched meter data
  const [error, setError] = useState(null); // Error state

  // Fetch meter data
  const fetchMeterData = async () => {
    setMeterLoading(true);
    setError(null);

    try {
      const response = await getMeterManagement();

      console.log("Full API response:", response);
      console.log("Actual meters array:", response?.data?.data);

      setMeters(response?.data ?? []);
    } catch (error) {
      console.error("Failed to fetch meter data:", error);
      setError("Failed to load meter data. Please try again later.");
    } finally {
      setMeterLoading(false);
    }
  };

  useEffect(() => {
    fetchMeterData(); // Fetch accounts when component mounts
  }, []);

  const [expandedAccount, setExpandedAccount] = useState(null);
  const toggleAccount = (index) => {
    setExpandedAccount((prev) => (prev === index ? null : index));
  };

  // Settings parameter curd functionality Starts
  const getData = async () => {
    try {
      const res = await getAdminSettingsList();

      const formatted = res.data.map((item) => ({
        id: item.id,
        name: item.field_name || item.name,
        value: item.value,
        unit: item.unit,
        displayName: item.display_name,
        status: item.active ? "Active" : "Inactive",
      }));

      setParameters([...formatted].reverse());
    } catch (error) {
      console.log(error);
    }
  };

  const handleCreate = async () => {
    if (!validateForm()) return;
    try {
      const payload = {
        name: newParameter.name,
        value: Number(newParameter.value),
        unit: newParameter.unit,
        display_name: newParameter.displayName,
        active: newParameter.status ? 1 : 0,
      };

      console.log("isEditMode:", isEditMode);
      console.log("editId:", editId);
      console.log("Payload:", payload);

      if (isEditMode) {
        if (!editId) {
          console.log("editId missing");
          return;
        }

        console.log("Calling EDIT API...");
        await editAdminSetting(editId, payload);
        console.log("Edit API called");
      } else {
        console.log("Calling CREATE API...");
        await createSettingsParameters(payload);
        console.log("Create API called");
      }

      await getData();

      setIsEditMode(false);
      setEditId(null);
      setShowAddParameterModal(false);
      resetParameterForm();
    } catch (error) {
      console.log("API errorrrr:", error.response?.data);
    }
  };

  // delete
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleDelete = async () => {
    console.log("OK button clicked");
    console.log("deleteId value is:", deleteId);

    try {
      if (!deleteId) {
        console.log("deleteId is null or undefined");
        return;
      }

      await deleteAdminSetting(deleteId);

      setParameters((prev) => prev.filter((item) => item.id !== deleteId));

      console.log("Deleted successfully");

      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (error) {
      console.log("Delete API error:", error);
    }
  };

  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleEditClick = (item) => {
    console.log("Edit clicked", item);

    setIsEditMode(true);
    setEditId(item.id);

    setNewParameter({
      name: item.name,
      value: item.value,
      unit: item.unit,
      displayName: item.displayName,
      status: item.status === "Active",
    });

    setShowAddParameterModal(true);
  };

  const resetParameterForm = () => {
    setNewParameter({
      name: "",
      value: "",
      unit: "",
      displayName: "",
      status: true,
    });
  };

  const [parameterErrors, setParameterErrors] = useState({});
  const validateForm = () => {
    const newErrors = {};

    if (!newParameter.name?.trim()) {
      newErrors.name = "Name is required";
    }

    if (!newParameter.value?.toString().trim()) {
      newErrors.value = "Value is required";
    } else if (isNaN(newParameter.value)) {
      newErrors.value = "Value must be a number";
    }

    if (!newParameter.unit?.trim()) {
      newErrors.unit = "Unit is required";
    }

    if (!newParameter.displayName?.trim()) {
      newErrors.displayName = "Display Name is required";
    }

    setParameterErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (showAddParameterModal) {
      setParameterErrors({});
    }
  }, [showAddParameterModal]);

  // Settings parameter curd functionality Ends

  // meter history

  const [changeLogList, setChangeLogList] = useState([]);
  const [groupedData, setGroupedData] = useState({});
  const [entityDetails, setEntityDetails] = useState({});

  const [openType, setOpenType] = useState(null); // METER / ACCOUNTS etc
  const [openEntity, setOpenEntity] = useState(null); // meter-123

  const [currentPage, setCurrentPage] = useState({});

  const fetchChangeLog = async () => {
    try {
      const res = await getChangeLog();

      const sorted = res.data.data.sort(
        (a, b) =>
          new Date(b.last_modified_date) - new Date(a.last_modified_date),
      );

      const grouped = sorted.reduce((acc, item) => {
        const type = item.entity_type;

        if (!acc[type]) {
          acc[type] = [];
        }

        acc[type].push(item);
        return acc;
      }, {});

      setGroupedData(grouped);
      setChangeLogList(sorted);
    } catch (error) {
      console.log("Change log error:", error);
    }
  };
  const getPrimaryKey = (item) => {
    if (!item.entity_pk) return null;
    return Object.values(item.entity_pk)[0];
  };
  const fetchEntityDetails = async (item) => {
    const entityType = item.entity_type;
    const pk = getPrimaryKey(item);
    const key = `${entityType}-${pk}`;

    if (!entityType || !pk) return;

    // Prevent multiple API calls
    if (entityDetails[key]) return;

    try {
      const res = await getEntityChangeLog(entityType, pk);

      setEntityDetails((prev) => ({
        ...prev,
        [key]: res.data.data,
      }));
    } catch (error) {
      console.log("Entity detail error:", error);
    }
  };

  const getPaginationRange = (current, total) => {
    const delta = 1;
    const range = [];
    const rangeWithDots = [];

    for (let i = 1; i <= total; i++) {
      if (
        i === 1 ||
        i === total ||
        (i >= current - delta && i <= current + delta)
      ) {
        range.push(i);
      }
    }

    let last = 0;
    for (let i of range) {
      if (i - last > 1) {
        rangeWithDots.push("...");
      }
      rangeWithDots.push(i);
      last = i;
    }

    return rangeWithDots;
  };

  useEffect(() => {
    fetchChangeLog();
  }, []);

  const allTabs = [
    { id: "settings", label: "Settings", icon: Settings },
    { id: "users", label: "Users", icon: Users },
    { id: "accounts", label: "Accounts", icon: Building2 },
    { id: "meter-management", label: "Meter Management", icon: Gauge },
    { id: "meter-history", label: "Meter History", icon: History },
    {
      id: "leak-rate",
      label: "Maintenance Logs",
      icon: Droplet,
    },
    {
      id: "leak-rate-water",
      label: "Water Rates",
      icon: DollarSign,
      
    },
  ];

  //  Filter based on user type
  const tabs =
    userType === "U"
      ? allTabs.filter(
          (tab) =>
            !["settings", "meter-management", "leak-rate", "users"].includes(
              tab.id,
            ),
        )
      : allTabs;

  const [isTypingPassword, setIsTypingPassword] = useState(false);

  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });
  };

  // users sort

  const handleUserSort = (key) => {
    let direction = "asc";

    if (userSort.key === key && userSort.direction === "asc") {
      direction = "desc";
    }

    setUserSort({ key, direction });
  };

  // account sort

  const handleAccountSort = (key) => {
    let direction = "asc";

    if (accountSort.key === key && accountSort.direction === "asc") {
      direction = "desc";
    }

    setAccountSort({ key, direction });
  };

  // account override name edit
  // 🔽 ADD BELOW YOUR OTHER FUNCTIONS (inside component)
  const handleUserNameUpdate = async () => {
    if (!editOverrideId) {
      toast.error("Invalid ID");
      return;
    }

    if (!editUserName.trim()) {
      toast.error("Override name cannot be empty");
      return;
    }

    try {
      const payload = {
        override_name: editUserName,
      };

      await editOverrideName(editOverrideId, payload);

      toast.success("Override name updated successfully");

      setShowEditUserNameModal(false);

      fetchAccounts(); // refresh table
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Update failed");
    }
  };

  return (
    <>
      {/* Header */}
      <motion.div
        className="mb-6"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1
          className="text-4xl font-bold text-transparent bg-linear-to-r"
          style={{
            backgroundImage: `linear-gradient(135deg, ${colors.primary}, ${colors.secondary})`,
            WebkitTextFillColor: "transparent",
            WebkitBackgroundClip: "text",
            lineHeight: "52px",
          }}
        >
          Account Settings
        </h1>
        <p className="text-sm mt-1" style={{ color: colors.textSecondary }}>
          Manage system parameters, users, and configurations
        </p>
      </motion.div>

      {/* Tab Controls */}
      <motion.div
        className="flex gap-3 mb-6 flex-wrap"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg border transition-all duration-300 relative overflow-hidden group`}
            style={{
              background:
                activeTab === tab.id ? `${colors.primary}20` : colors.cardBg, // Dynamic background color
              borderColor:
                activeTab === tab.id ? colors.primary : colors.border, // Dynamic border color
              boxShadow:
                activeTab === tab.id ? `0 0 20px ${colors.primary}40` : "none", // Box shadow on active tab
            }}
          >
            {activeTab === tab.id && (
              <motion.div
                className="absolute inset-0"
                style={{
                  background: `linear-gradient(to right, transparent, ${colors.primary}30, transparent)`, // Gradient for active tab
                }}
                animate={{ x: ["-100%", "200%"] }}
                transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
              />
            )}
            <tab.icon
              className="w-4 h-4 relative z-10"
              style={{
                color:
                  activeTab === tab.id ? colors.primary : colors.textSecondary, // Icon color
              }}
            />
            <span
              className="text-sm font-semibold relative z-10"
              style={{
                color:
                  activeTab === tab.id ? colors.text : colors.textSecondary, // Text color
              }}
            >
              {tab.label}
            </span>
          </button>
        ))}
      </motion.div>

      {/* Settings Content */}
      {activeTab === "settings" && (
        <>
          {selectedDistrict === "FB151" && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div
                className=" backdrop-blur-sm rounded-xl border p-6 mb-6"
                style={{
                  borderColor: colors.border, // Dynamic border color
                  backgroundColor: colors.cardBg, // Dynamic background color
                }}
              >
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  {/* Left Section */}
                  <div>
                    <div className="flex items-center gap-2">
                      <h2
                        className="text-2xl font-bold"
                        style={{
                          color: colors.primary, // Primary color for heading
                        }}
                      >
                        Monthly Source Data
                      </h2>
                      <InfoTooltip text="Upload source data by selecting the required year and month, then click Upload" />
                    </div>

                    {/* <div className="flex flex-wrap gap-4 mt-4"> */}

                    {/* <select
                        className=" border  rounded-md px-4 py-2  focus:outline-none focus:ring-2 focus:ring-[#00b8f1]"
                        style={{
                          borderColor: colors.border, 
                          backgroundColor: colors.cardBg, 
                          color: colors.text, 
                        }}
                      >
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select> */}

                    {/* <select
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        className=" border  rounded-md px-4 py-2  focus:outline-none focus:ring-2 focus:ring-[#00b8f1]"
                        style={{
                          borderColor: colors.border, 
                          backgroundColor: colors.cardBg, 
                          color: colors.text, 
                        }}
                      >
                        {months.map((month) => (
                          <option key={month} value={month}>
                            {month}
                          </option>
                        ))}
                      </select> */}
                    {/* </div> */}
                  </div>

                  {/* Right Section */}
                  <div className="flex justify-start md:justify-end">
                    {/* Hidden file input */}
                    <input
                      type="file"
                      ref={fileInputRef}
                      accept=".xlsx"
                      className="hidden"
                      onChange={handleFileUpload}
                    />

                    {/* Upload Button */}
                    <button
                      type="button"
                      onClick={() => fileInputRef.current.click()}
                      className="px-6 py-2 rounded-md text-white font-medium transition-all hover:scale-[1.03] active:scale-[0.98]"
                      style={{
                        backgroundImage: `linear-gradient(135deg, ${colors.primary}, ${colors.secondary})`,
                      }}
                    >
                      Upload XLSX
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div
              className=" backdrop-blur-sm rounded-xl border overflow-hidden mb-7"
              style={{
                borderColor: colors.border, // Dynamic border color
                backgroundColor: colors.cardBg, // Dynamic background color
              }}
            >
              <div
                className="flex items-center justify-between p-6 border-b"
                style={{ borderColor: colors.border }}
              >
                <h2
                  className="text-xl font-bold text-transparent bg-clip-text"
                  style={{
                    backgroundImage: `linear-gradient(to right, ${colors.primary}, ${colors.secondary})`,
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    lineHeight: "normal",
                  }}
                >
                  Default Parameters
                </h2>
                <button
                  className="flex items-center gap-2 px-4 py-2 border rounded-lg  text-sm font-medium hover:shadow-lg hover:shadow-[#00b8f1]/30 transition-all duration-300"
                  style={{
                    // background: colors.primary,
                    color: colors.text, // Button text color
                    borderColor: colors.border, // Button border color
                  }}
                  onClick={() => setShowAddParameterModal(true)}
                >
                  <Plus className="w-4 h-4" />
                  Add New
                </button>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr
                      className="border-b"
                      style={{
                        backgroundColor: colors.background,
                        border: colors.border,
                      }}
                    >
                      {[
                        { label: "Name", key: "name" },
                        { label: "Value", key: "value" },
                        { label: "Unit", key: "unit" },
                        { label: "Display Name", key: "displayName" },
                        { label: "Status", key: "status" },
                      ].map((h) => (
                        <th
                          key={h.key}
                          onClick={() => handleSort(h.key)}
                          className="text-left py-4 px-6 font-semibold text-sm cursor-pointer"
                          style={{ color: colors.textSecondary }}
                        >
                          <span className="flex items-center gap-2 select-none">
                            {h.label}

                            {sortConfig.key === h.key ? (
                              sortConfig.direction === "asc" ? (
                                <ArrowUp
                                  className="w-4 h-4"
                                  style={{ color: colors.primary }}
                                />
                              ) : (
                                <ArrowDown
                                  className="w-4 h-4"
                                  style={{ color: colors.primary }}
                                />
                              )
                            ) : (
                              <ArrowUpDown
                                className="w-4 h-4"
                                style={{ color: colors.primary }}
                              />
                            )}
                          </span>
                        </th>
                      ))}

                      <th
                        className="text-center py-4 px-6 font-semibold text-sm"
                        style={{ color: colors.textSecondary }}
                      >
                        Edit
                      </th>

                      <th
                        className="text-center py-4 px-6 font-semibold text-sm"
                        style={{ color: colors.textSecondary }}
                      >
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="7" className="text-center py-6 text-white">
                          <div className="flex items-center justify-center h-full">
                            <Spin size="large" />
                          </div>
                        </td>
                      </tr>
                    ) : parameters.length > 0 ? (
                      // parameters.map((param, index) => (
                      sortedParameters.map((param, index) => (
                        <motion.tr
                          key={index}
                          className="border-b transition-colors"
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3, delay: index * 0.05 }}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? colors.rowAlt1 : colors.rowAlt2,
                            borderColor: colors.border,
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              colors.hoverBg)
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              index % 2 === 0 ? colors.rowAlt1 : colors.rowAlt2)
                          }
                        >
                          <td
                            className="py-4 px-6  text-sm"
                            style={{ color: colors.text }}
                          >
                            {param.name}
                          </td>
                          <td
                            className="py-4 px-6  text-sm"
                            style={{ color: colors.text }}
                          >
                            {param.value}
                          </td>
                          <td
                            className="py-4 px-6  text-sm"
                            style={{ color: colors.text }}
                          >
                            {param.unit}
                          </td>
                          <td
                            className="py-4 px-6  text-sm"
                            style={{ color: colors.text }}
                          >
                            {param.displayName}
                          </td>
                          <td className="py-4 px-6">
                            <span
                              className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border"
                              style={{
                                backgroundColor:
                                  param.status === "Active"
                                    ? `${colors.primary}20`
                                    : colors.rowAlt2,
                                color:
                                  param.status === "Active"
                                    ? colors.primary
                                    : colors.textSecondary,
                                borderColor: colors.border,
                              }}
                            >
                              {param.status}
                            </span>
                          </td>
                          <td className="py-4 px-6 text-center">
                            <button
                              className="inline-flex items-center justify-center w-8 h-8 rounded-lg transition-colors group"
                              style={{
                                backgroundColor: "transparent",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  colors.primary + "20")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  "transparent")
                              }
                              onClick={() => handleEditClick(param)}
                            >
                              <Pencil
                                className="w-4 h-4 group-hover:scale-110 transition-transform"
                                style={{ color: colors.primary }}
                              />
                            </button>
                          </td>
                          <td className="py-4 px-6 text-center">
                            <button
                              className="inline-flex items-center justify-center w-8 h-8 rounded-lg transition-colors group"
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  colors.danger + "20")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  "transparent")
                              }
                              onClick={() => {
                                console.log("Trash clicked. param =", param);
                                console.log("param.id =", param.id);
                                setDeleteId(param.id);
                                setShowDeleteModal(true);
                              }}
                            >
                              <Trash2
                                className="w-4 h-4 group-hover:scale-110 transition-transform"
                                style={{ color: colors.danger }}
                              />
                            </button>
                          </td>
                        </motion.tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-6 text-white">
                          No Data Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {/* USERS PAGINATION FOOTER */}
                {userTotalPages > 0 && (
                  <div
                    className="flex items-center justify-between p-4 border-t flex-wrap gap-4"
                    style={{
                      borderColor: colors.border,
                      backgroundColor: colors.cardBg,
                    }}
                  >
                    <div
                      className="text-xs"
                      style={{ color: colors.textSecondary }}
                    >
                      Showing {(userPage - 1) * userPageSize + 1} to{" "}
                      {Math.min(userPage * userPageSize, sortedUsers.length)} of{" "}
                      {sortedUsers.length} records
                    </div>

                    <div className="flex items-center gap-6 flex-wrap">
                      <div className="flex items-center gap-2">
                        <button
                          disabled={userPage === 1}
                          onClick={() => setUserPage((p) => p - 1)}
                          className="p-1.5 rounded-md border transition-all"
                          style={{
                            borderColor:
                              userPage === 1 ? colors.border : colors.primary,
                            color:
                              userPage === 1
                                ? colors.textSecondary
                                : colors.primary,
                          }}
                        >
                          <ChevronLeft className="w-5 h-5" />
                        </button>

                        <div className="flex items-center gap-2 px-2">
                          <span
                            className="text-sm"
                            style={{ color: colors.textSecondary }}
                          >
                            Page
                          </span>
                          <select
                            value={userPage}
                            onChange={(e) =>
                              setUserPage(Number(e.target.value))
                            }
                            className="text-sm rounded-md px-2 py-1 outline-none border cursor-pointer"
                            style={{
                              backgroundColor: colors.background,
                              borderColor: colors.border,
                              color: colors.text,
                            }}
                          >
                            {Array.from(
                              { length: userTotalPages },
                              (_, i) => i + 1,
                            ).map((p) => (
                              <option key={p} value={p}>
                                {p}
                              </option>
                            ))}
                          </select>
                          <span
                            className="text-sm"
                            style={{ color: colors.textSecondary }}
                          >
                            of {userTotalPages}
                          </span>
                        </div>

                        <button
                          disabled={userPage === userTotalPages}
                          onClick={() => setUserPage((p) => p + 1)}
                          className="p-1.5 rounded-md border transition-all"
                          style={{
                            borderColor:
                              userPage === userTotalPages
                                ? colors.border
                                : colors.primary,
                            color:
                              userPage === userTotalPages
                                ? colors.textSecondary
                                : colors.primary,
                          }}
                        >
                          <ChevronRight className="w-5 h-5" />
                        </button>
                      </div>

                      <div
                        className="flex items-center gap-2 text-sm"
                        style={{ color: colors.textSecondary }}
                      >
                        <span>Rows:</span>
                        <select
                          value={userPageSize}
                          onChange={(e) => {
                            setUserPageSize(Number(e.target.value));
                            setUserPage(1);
                          }}
                          className="rounded px-2 py-1 text-sm border outline-none cursor-pointer"
                          style={{
                            background: colors.background,
                            borderColor: colors.border,
                            color: colors.text,
                          }}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        </>
      )}

      {/* Users Content */}
      {activeTab === "users" && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div
            className="backdrop-blur-sm rounded-xl border overflow-hidden mb-8"
            style={{
              background: colors.cardBg,
              borderColor: colors.border,
            }}
          >
            <div
              className="flex items-center justify-between p-6 border-b"
              style={{ borderColor: colors.border }}
            >
              <h2
                className="text-xl font-bold text-transparent bg-clip-text"
                style={{
                  backgroundImage: colors.gradient,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Existing Users
              </h2>
              <button
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white text-sm font-medium transition-all"
                style={{ background: colors.gradient }}
                onClick={() => setShowUserRegistrationModal(true)}
              >
                <Plus className="w-4 h-4" />
                User Registration
              </button>
            </div>

            {userLoading ? (
              <div className="text-center py-4">
                <div className="flex items-center justify-center h-[75vh] pt-5">
                  <Spin size="large" />
                </div>
              </div> // Show loading state
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr
                      className="border-b"
                      style={{
                        borderColor: colors.border,
                        background: colors.rowAlt2,
                      }}
                    >
                      {[
                        { label: "First Name", key: "first_name" },
                        { label: "Last Name", key: "last_name" },
                        { label: "Email ID", key: "email" },
                        { label: "User Type", key: "type_diplay_name" },
                        { label: "Status", key: "is_active" },
                      ].map((h) => (
                        <th
                          key={h.key}
                          onClick={() => handleUserSort(h.key)}
                          className="text-left py-4 px-6 font-semibold text-sm cursor-pointer"
                          style={{ color: colors.textSecondary }}
                        >
                          <span className="flex items-center gap-2">
                            {h.label}

                            {userSort.key === h.key ? (
                              userSort.direction === "asc" ? (
                                <ArrowUp
                                  className="w-4 h-4"
                                  style={{ color: colors.primary }}
                                />
                              ) : (
                                <ArrowDown
                                  className="w-4 h-4"
                                  style={{ color: colors.primary }}
                                />
                              )
                            ) : (
                              <ArrowUpDown
                                className="w-4 h-4"
                                style={{ color: colors.primary }}
                              />
                            )}
                          </span>
                        </th>
                      ))}

                      <th
                        className="text-center py-4 px-6 font-semibold text-sm"
                        style={{ color: colors.textSecondary }}
                      >
                        Edit
                      </th>

                      <th
                        className="text-center py-4 px-6 font-semibold text-sm"
                        style={{ color: colors.textSecondary }}
                      >
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {users.map((user, index) => ( */}
                    {paginatedUsers.map((user, index) => (
                      <motion.tr
                        key={user.id}
                        className="border-b transition-colors"
                        style={{
                          borderColor: colors.border,
                          backgroundColor:
                            index % 2 === 0 ? colors.rowAlt1 : colors.rowAlt2,
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            colors.hoverBg)
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            index % 2 === 0 ? colors.rowAlt1 : colors.rowAlt2)
                        }
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: index * 0.05 }}
                      >
                        <td
                          className="py-4 px-6 text-sm"
                          style={{ color: colors.text }}
                        >
                          {user.first_name}
                        </td>
                        <td
                          className="py-4 px-6 text-sm"
                          style={{ color: colors.text }}
                        >
                          {user.last_name}
                        </td>
                        <td
                          className="py-4 px-6 text-sm"
                          style={{ color: colors.text }}
                        >
                          {user.email}
                        </td>
                        <td
                          className="py-4 px-6 text-sm"
                          style={{ color: colors.text }}
                        >
                          {user.type_diplay_name}
                        </td>
                        <td className="py-4 px-6">
                          <span
                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${user.is_active ? "bg-green-500/20 text-green-400 border border-green-500/30" : "bg-red-500/20 text-red-400 border border-red-500/30"}`}
                          >
                            {user.is_active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        {user.type_name !== "SA" &&
                          user.type_diplay_name !== "Super Admin" && (
                            <>
                              <td className="py-4 px-6 text-center">
                                <button
                                  className="w-8 h-8 rounded-lg transition"
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      colors.hoverBg)
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "transparent")
                                  }
                                  onClick={() => {
                                    setEditUserId(user.id);

                                    const getUserTypeCode = (type) => {
                                      if (type === "Super Admin") return "SA";
                                      if (type === "Admin") return "A";
                                      if (type === "User") return "U";
                                      return type;
                                    };

                                    setEditUserData({
                                      firstName: user.first_name,
                                      lastName: user.last_name,
                                      email: user.email,
                                      userType: getUserTypeCode(
                                        user.user_type || user.type_diplay_name,
                                      ),
                                      isActive:
                                        user.is_active === 1 ||
                                        user.is_active === true,
                                      districts: user.districts
                                        ? user.districts.split(",")
                                        : [],
                                    });

                                    setShowEditUserModal(true);
                                  }}
                                >
                                  <Pencil
                                    className="w-4 h-4  mx-auto"
                                    style={{ color: colors.primary }}
                                  />
                                </button>
                              </td>

                              <td className="py-4 px-6 text-center">
                                <button
                                  className="w-8 h-8 rounded-lg"
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      colors.hoverBg)
                                  }
                                  onClick={() => {
                                    setDeleteUserId(user.id);
                                    setShowDeleteUserModal(true);
                                  }}
                                >
                                  <Trash2
                                    className="w-4 h-4  mx-auto"
                                    style={{ color: colors.danger }}
                                  />
                                </button>
                              </td>
                            </>
                          )}
                      </motion.tr>
                    ))}
                  </tbody>
                </table>
                {/* USERS PAGINATION FOOTER */}
                {userTotalPages > 0 && (
                  <div
                    className="flex items-center justify-between p-4 border-t flex-wrap gap-4"
                    style={{
                      borderColor: colors.border,
                      backgroundColor: colors.cardBg,
                    }}
                  >
                    <div
                      className="text-xs"
                      style={{ color: colors.textSecondary }}
                    >
                      Showing {userStartIndex + 1} to{" "}
                      {Math.min(
                        userStartIndex + userPageSize,
                        userDisplayCount,
                      )}{" "}
                      of {userDisplayCount} records
                    </div>

                    <div className="flex items-center gap-6 flex-wrap">
                      <div className="flex items-center gap-2">
                        <button
                          disabled={userPage === 1}
                          onClick={() => setUserPage((p) => Math.max(p - 1, 1))}
                          className="p-1.5 rounded-md border transition-all"
                          style={{
                            borderColor:
                              userPage === 1 ? colors.border : colors.primary,
                            color:
                              userPage === 1
                                ? colors.textSecondary
                                : colors.primary,
                            opacity: userPage === 1 ? 0.3 : 1,
                            cursor: userPage === 1 ? "not-allowed" : "pointer",
                          }}
                        >
                          <ChevronLeft className="w-5 h-5" />
                        </button>

                        <div className="flex items-center gap-2 px-2">
                          <span
                            className="text-sm"
                            style={{ color: colors.textSecondary }}
                          >
                            Page
                          </span>
                          <select
                            value={userPage}
                            onChange={(e) =>
                              setUserPage(Number(e.target.value))
                            }
                            className="text-sm rounded-md px-2 py-1 outline-none border cursor-pointer"
                            style={{
                              backgroundColor: colors.background,
                              borderColor: colors.border,
                              color: colors.text,
                            }}
                          >
                            {Array.from(
                              { length: userTotalPages },
                              (_, i) => i + 1,
                            ).map((p) => (
                              <option key={p} value={p}>
                                {p}
                              </option>
                            ))}
                          </select>
                          <span
                            className="text-sm"
                            style={{ color: colors.textSecondary }}
                          >
                            of {userTotalPages}
                          </span>
                        </div>

                        <button
                          disabled={userPage === userTotalPages}
                          onClick={() =>
                            setUserPage((p) => Math.min(p + 1, userTotalPages))
                          }
                          className="p-1.5 rounded-md border transition-all"
                          style={{
                            borderColor:
                              userPage === userTotalPages
                                ? colors.border
                                : colors.primary,
                            color:
                              userPage === userTotalPages
                                ? colors.textSecondary
                                : colors.primary,
                            opacity: userPage === userTotalPages ? 0.3 : 1,
                            cursor:
                              userPage === userTotalPages
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          <ChevronRight className="w-5 h-5" />
                        </button>
                      </div>

                      <div
                        className="flex items-center gap-2 text-sm"
                        style={{ color: colors.textSecondary }}
                      >
                        <span>Rows:</span>
                        <select
                          value={userPageSize}
                          onChange={(e) => {
                            setUserPageSize(Number(e.target.value));
                            setUserPage(1); // Important: Reset to first page
                          }}
                          className="rounded px-2 py-1 text-sm border outline-none cursor-pointer"
                          style={{
                            background: colors.background,
                            borderColor: colors.border,
                            color: colors.text,
                          }}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </motion.div>
      )}

      {/* Accounts Content */}
      {activeTab === "accounts" && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div
            className="backdrop-blur-sm rounded-xl border overflow-hidden mb-8"
            style={{
              background: colors.cardBg,
              borderColor: colors.border,
            }}
          >
            <div
              className="p-6 border-b"
              style={{ borderColor: colors.border }}
            >
              <h2
                className="text-xl font-bold text-transparent bg-clip-text"
                style={{
                  backgroundImage: colors.gradient,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Account Listing
              </h2>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr
                    className="border-b"
                    style={{
                      borderColor: colors.border,
                      background: colors.rowAlt2,
                    }}
                  >
                    <th
                      onClick={() => handleAccountSort("account_full_name")}
                      className="text-left py-4 px-6 font-semibold text-sm cursor-pointer"
                      style={{ color: colors.textSecondary }}
                    >
                      <span className="flex items-center gap-2">
                        {selectedDistrict === "FB151"
                          ? "Account ID"
                          : "Beacon Name"}

                        {accountSort.key === "account_full_name" ? (
                          accountSort.direction === "asc" ? (
                            <ArrowUp
                              className="w-4 h-4"
                              style={{ color: colors.primary }}
                            />
                          ) : (
                            <ArrowDown
                              className="w-4 h-4"
                              style={{ color: colors.primary }}
                            />
                          )
                        ) : (
                          <ArrowUpDown
                            className="w-4 h-4"
                            style={{ color: colors.primary }}
                          />
                        )}
                      </span>
                    </th>

                    <th
                      onClick={() => handleAccountSort("overided_name")}
                      className="text-left py-4 px-6 font-semibold text-sm cursor-pointer"
                      style={{ color: colors.textSecondary }}
                    >
                      <span className="flex items-center gap-2">
                        Override Name
                        {accountSort.key === "overided_name" ? (
                          accountSort.direction === "asc" ? (
                            <ArrowUp
                              className="w-4 h-4"
                              style={{ color: colors.primary }}
                            />
                          ) : (
                            <ArrowDown
                              className="w-4 h-4"
                              style={{ color: colors.primary }}
                            />
                          )
                        ) : (
                          <ArrowUpDown
                            className="w-4 h-4"
                            style={{ color: colors.primary }}
                          />
                        )}
                      </span>
                    </th>
                    {hasOverrideEditPermission && (
                      <th
                        className="text-center py-4 px-6 font-semibold text-sm"
                        style={{ color: colors.textSecondary }}
                      >
                        Action
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {accountsLoading ? (
                    <tr>
                      <td
                        colSpan="2"
                        className="text-center py-4"
                        style={{ color: colors.text }}
                      >
                        <div className="flex items-center justify-center h-full">
                          <Spin size="large" />
                        </div>
                      </td>
                    </tr>
                  ) : accounts.length === 0 ? (
                    <tr>
                      <td
                        colSpan="2"
                        className="text-center py-4"
                        style={{ color: colors.text }}
                      >
                        No Records Found
                      </td>
                    </tr>
                  ) : (
                    // accounts.map((account, index) => (
                    paginatedAccounts.map((account, index) => (
                      <tr
                        key={account.id}
                        className="border-b transition-colors"
                        style={{
                          borderColor: colors.border,
                          backgroundColor:
                            index % 2 === 0 ? colors.rowAlt1 : colors.rowAlt2,
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            colors.hoverBg)
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            index % 2 === 0 ? colors.rowAlt1 : colors.rowAlt2)
                        }
                      >
                        <td
                          className="py-4 px-6 text-sm"
                          style={{ color: colors.text }}
                        >
                          {account.account_full_name}
                        </td>
                        <td
                          className="py-4 px-6 text-sm"
                          style={{ color: colors.text }}
                        >
                          {account.overided_name || "-"}
                        </td>
                        {hasOverrideEditPermission && (
                          <td className="py-4 px-6 text-center">
                            <button
                              className="w-8 h-8 rounded-lg transition"
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  colors.hoverBg)
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  "transparent")
                              }
                              onClick={() => {
                                setEditOverrideId(account.id);
                                setEditUserName(account.overided_name || "");
                                setShowEditUserNameModal(true);
                              }}
                            >
                              <Pencil
                                className="w-4 h-4 mx-auto"
                                style={{ color: colors.primary }}
                              />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              {/* ACCOUNTS PAGINATION FOOTER */}
              {accTotalPages > 0 && (
                <div
                  className="flex items-center justify-between p-4 border-t flex-wrap gap-4"
                  style={{
                    borderColor: colors.border,
                    backgroundColor: colors.cardBg,
                  }}
                >
                  <div
                    className="text-xs"
                    style={{ color: colors.textSecondary }}
                  >
                    Showing {accStartIndex + 1} to{" "}
                    {Math.min(accStartIndex + accPageSize, accDisplayCount)} of{" "}
                    {accDisplayCount} records
                  </div>

                  <div className="flex items-center gap-6 flex-wrap">
                    <div className="flex items-center gap-2">
                      <button
                        disabled={accPage === 1}
                        onClick={() => setAccPage((p) => Math.max(p - 1, 1))}
                        className="p-1.5 rounded-md border transition-all"
                        style={{
                          borderColor:
                            accPage === 1 ? colors.border : colors.primary,
                          color:
                            accPage === 1
                              ? colors.textSecondary
                              : colors.primary,
                          opacity: accPage === 1 ? 0.3 : 1,
                        }}
                      >
                        <ChevronLeft className="w-5 h-5" />
                      </button>

                      <div className="flex items-center gap-2 px-2">
                        <span
                          className="text-sm"
                          style={{ color: colors.textSecondary }}
                        >
                          Page
                        </span>
                        <select
                          value={accPage}
                          onChange={(e) => setAccPage(Number(e.target.value))}
                          className="text-sm rounded-md px-2 py-1 outline-none border cursor-pointer"
                          style={{
                            backgroundColor: colors.background,
                            borderColor: colors.border,
                            color: colors.text,
                          }}
                        >
                          {Array.from(
                            { length: accTotalPages },
                            (_, i) => i + 1,
                          ).map((p) => (
                            <option key={p} value={p}>
                              {p}
                            </option>
                          ))}
                        </select>
                        <span
                          className="text-sm"
                          style={{ color: colors.textSecondary }}
                        >
                          of {accTotalPages}
                        </span>
                      </div>

                      <button
                        disabled={accPage === accTotalPages}
                        onClick={() =>
                          setAccPage((p) => Math.min(p + 1, accTotalPages))
                        }
                        className="p-1.5 rounded-md border transition-all"
                        style={{
                          borderColor:
                            accPage === accTotalPages
                              ? colors.border
                              : colors.primary,
                          color:
                            accPage === accTotalPages
                              ? colors.textSecondary
                              : colors.primary,
                          opacity: accPage === accTotalPages ? 0.3 : 1,
                        }}
                      >
                        <ChevronRight className="w-5 h-5" />
                      </button>
                    </div>

                    <div
                      className="flex items-center gap-2 text-sm"
                      style={{ color: colors.textSecondary }}
                    >
                      <span>Rows:</span>
                      <select
                        value={accPageSize}
                        onChange={(e) => {
                          setAccPageSize(Number(e.target.value));
                          setAccPage(1);
                        }}
                        className="rounded px-2 py-1 text-sm border outline-none cursor-pointer"
                        style={{
                          background: colors.background,
                          borderColor: colors.border,
                          color: colors.text,
                        }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </motion.div>
      )}

      {/* Meter Management Content */}
      {activeTab === "meter-management" && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="space-y-6"
        >
          {/* New Meters Section */}
          <div
            className="backdrop-blur-sm rounded-xl border overflow-hidden"
            style={{
              background: colors.cardBg,
              borderColor: colors.border,
            }}
          >
            <div
              className="p-6 border-b"
              style={{ borderColor: colors.border }}
            >
              <h2
                className="text-xl font-bold text-transparent bg-clip-text"
                style={{
                  backgroundImage: colors.gradient,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                New Meters
              </h2>
            </div>
            <div className="p-12 flex flex-col items-center justify-center">
              {/* Show loading spinner, error, or success message */}
              {meterloading ? (
                <div
                  className="w-16 h-16 mb-4"
                  style={{ color: colors.textSecondary }}
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                  </svg>
                </div>
              ) : error ? (
                <p style={{ color: colors.textSecondary }} className="text-sm">
                  {error}
                </p> // Error message
              ) : meters.length === 0 ? (
                <p style={{ color: colors.textSecondary }} className="text-sm">
                  No New Meter Found
                </p>
              ) : (
                <p style={{ color: colors.textSecondary }} className="text-sm">
                  {meters.length} Accounts loaded successfully
                </p>
              )}
            </div>
          </div>

          {/* Account-Wise Meter Log Section */}
          <div
            className="backdrop-blur-sm rounded-xl border overflow-hidden mb-8"
            style={{
              background: colors.cardBg,
              borderColor: colors.border,
            }}
          >
            <div
              className="p-6 border-b"
              style={{ borderColor: colors.border }}
            >
              <h2
                className="text-xl font-bold text-transparent bg-clip-text"
                style={{
                  backgroundImage: colors.gradient,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Account-Wise Meter Log
              </h2>
            </div>
            <div className="p-0">
              {meterloading ? (
                <div
                  className="text-center py-6"
                  style={{ color: colors.textSecondary }}
                >
                  <div className="flex items-center justify-center h-full pt-5">
                    <Spin size="large" />
                  </div>
                </div>
              ) : error ? (
                <div
                  className="text-center py-6"
                  style={{ color: colors.textSecondary }}
                >
                  {error}
                </div>
              ) : meters.length === 0 ? (
                <p
                  className="text-center py-6"
                  style={{ color: colors.textSecondary }}
                >
                  No meters available.
                </p>
              ) : (
                meters.map((item, index) => {
                  const isOpen = expandedAccount === index;

                  return (
                    <div
                      key={index}
                      className="border-b"
                      style={{ borderColor: colors.border }}
                    >
                      {/* ACCOUNT ROW */}
                      <button
                        onClick={() => toggleAccount(index)}
                        className="w-full text-left px-6 py-4 transition flex justify-between items-center"
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? colors.rowAlt1 : colors.rowAlt2,
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            colors.hoverBg)
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            index % 2 === 0 ? colors.rowAlt1 : colors.rowAlt2)
                        }
                      >
                        <span
                          className="font-semibold"
                          style={{ color: colors.textSecondary }}
                        >
                          {item.account || `Account ${index + 1}`}
                        </span>

                        <span
                          className="text-xl"
                          style={{ color: colors.primary }}
                        >
                          {isOpen ? "−" : "+"}
                        </span>
                      </button>

                      {/* EXPANDED TABLE */}
                      {isOpen && (
                        <div
                          className="p-6"
                          style={{ background: colors.rowAlt2 }}
                        >
                          {item.meters?.length > 0 ? (
                            <div className="overflow-x-auto">
                              <table
                                className="w-full text-sm text-left"
                                style={{ color: colors.text }}
                              >
                                <thead
                                  className="text-xs uppercase"
                                  style={{
                                    background: colors.background,
                                    color: colors.primary,
                                  }}
                                >
                                  <tr>
                                    <th className="px-4 py-3">Meter ID</th>
                                    <th className="px-4 py-3">Register No</th>
                                    <th className="px-4 py-3">Status</th>
                                    <th className="px-4 py-3">
                                      Flow Start Time
                                    </th>
                                    <th className="px-4 py-3">Flow End Time</th>
                                    <th className="px-4 py-3">Address</th>
                                    <th className="px-4 py-3">Meter Code</th>
                                    <th className="px-4 py-3">Meter Type</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {item.meters.map((meter, idx) => (
                                    <tr
                                      key={meter.meter_log_id || idx}
                                      className="border-b"
                                      style={{ borderColor: colors.border }}
                                    >
                                      <td className="px-4 py-3">
                                        {meter.meter_id ?? "-"}
                                      </td>
                                      <td className="px-4 py-3">
                                        {meter.register_number ?? "-"}
                                      </td>
                                      <td className="px-4 py-3 text-green-400">
                                        {meter.changed ?? "-"}
                                      </td>
                                      <td className="px-4 py-3">
                                        {meter.start_date ?? "-"}
                                      </td>
                                      <td className="px-4 py-3">
                                        {meter.end_date ?? "-"}
                                      </td>
                                      <td className="px-4 py-3">
                                        {[
                                          meter.location_address_line1,
                                          meter.location_address_line2,
                                          meter.location_address_line3,
                                          meter.location_city,
                                          meter.location_country,
                                        ]
                                          .filter(Boolean) // removes empty/null values
                                          .join(", ") || "-"}
                                      </td>
                                      <td className="px-4 py-3">
                                        {meter.code ?? "-"}
                                      </td>
                                      <td className="px-4 py-3">
                                        {meter.code_name ?? "-"}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <p
                              className="text-sm"
                              style={{ color: colors.textSecondary }}
                            >
                              No meters available for this account.
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </motion.div>
      )}

      {/* Meter History Content */}

      {activeTab === "meter-history" && (
        <motion.div
          className="backdrop-blur-sm rounded-xl border p-8 mb-8"
          style={{
            background: colors.cardBg,
            borderColor: colors.border,
          }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* <h3 className="text-2xl font-bold text-[#BDB9B5] mb-6 text-center">
      Change History
    </h3> */}

          {Object.keys(groupedData).length === 0 ? (
            <p style={{ color: colors.textSecondary }} className="text-center">
              No history found
            </p>
          ) : (
            <div className="space-y-5">
              {Object.keys(groupedData).map((type) => {
                const isTypeOpen = openType === type;
                const items = groupedData[type] || [];

                const ITEMS_PER_PAGE = 10;
                const page = currentPage[type] || 1;
                const start = (page - 1) * ITEMS_PER_PAGE;
                const paginatedItems = items.slice(
                  start,
                  start + ITEMS_PER_PAGE,
                );
                const totalPages = Math.ceil(items.length / ITEMS_PER_PAGE);

                return (
                  <div
                    key={type}
                    className="rounded-lg border overflow-hidden"
                    style={{
                      background: colors.rowAlt2,
                      borderColor: colors.border,
                    }}
                  >
                    {/* MAIN TYPE HEADER */}
                    <div
                      onClick={() => setOpenType(isTypeOpen ? null : type)}
                      className="cursor-pointer p-4 flex justify-between items-center transition"
                      style={{ background: colors.rowAlt1 }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = colors.hoverBg)
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = colors.rowAlt1)
                      }
                    >
                      <span
                        className="font-semibold"
                        style={{ color: colors.primary }}
                      >
                        {type.toUpperCase()}
                      </span>
                      <span style={{ color: colors.text }} className="text-lg">
                        {isTypeOpen ? "−" : "+"}
                      </span>
                    </div>

                    {/* TYPE BODY */}
                    {isTypeOpen && (
                      <div
                        className="p-4 space-y-3"
                        style={{ background: colors.cardBg }}
                      >
                        {paginatedItems.map((item, index) => {
                          const pk = item.entity_pk
                            ? Object.values(item.entity_pk)[0]
                            : null;

                          const entityKey = `${type}-${pk}`;
                          const isEntityOpen = openEntity === entityKey;

                          return (
                            <div
                              key={index}
                              className="rounded-md border"
                              style={{
                                background: colors.rowAlt2,
                                borderColor: colors.border,
                              }}
                            >
                              {/* ENTITY HEADER */}
                              <div
                                onClick={() => {
                                  setOpenEntity(
                                    isEntityOpen ? null : entityKey,
                                  );
                                  fetchEntityDetails(item);
                                }}
                                className="cursor-pointer p-3 flex justify-between items-center"
                              >
                                <div>
                                  <p
                                    className="text-sm"
                                    style={{ color: colors.text }}
                                  >
                                    ID: {pk}
                                  </p>
                                  <p
                                    className="text-xs"
                                    style={{ color: colors.textSecondary }}
                                  >
                                    {new Date(
                                      item.last_modified_date,
                                    ).toLocaleString()}
                                  </p>
                                </div>
                                <span style={{ color: colors.text }}>
                                  {isEntityOpen ? "−" : "+"}
                                </span>
                              </div>

                              {/* DETAIL BODY */}
                              {isEntityOpen && (
                                <div
                                  className="p-3 border-t"
                                  style={{ borderColor: colors.border }}
                                >
                                  {entityDetails[entityKey]?.length > 0 ? (
                                    entityDetails[entityKey].map((log, i) => (
                                      <div
                                        key={i}
                                        className="mb-3 p-3 rounded-md"
                                        style={{ background: colors.rowAlt1 }}
                                      >
                                        <p
                                          className="text-xs font-semibold"
                                          style={{ color: colors.primary }}
                                        >
                                          {log.operation_type}
                                        </p>

                                        <p
                                          className="text-xs mb-2"
                                          style={{
                                            color: colors.textSecondary,
                                          }}
                                        >
                                          {new Date(
                                            log.changed_at,
                                          ).toLocaleString()}
                                        </p>

                                        {Object.keys(log.column_diffs || {})
                                          .length > 0 ? (
                                          <div
                                            className="text-xs space-y-1"
                                            style={{ color: colors.text }}
                                          >
                                            {Object.entries(
                                              log.column_diffs,
                                            ).map(([field, values], idx) => (
                                              <div key={idx}>
                                                <span
                                                  style={{
                                                    color: colors.primary,
                                                  }}
                                                >
                                                  {field}
                                                </span>
                                                : {values.old} → {values.new}
                                              </div>
                                            ))}
                                          </div>
                                        ) : (
                                          <p
                                            className="text-xs"
                                            style={{
                                              color: colors.textSecondary,
                                            }}
                                          >
                                            {/* No field changes */}
                                          </p>
                                        )}
                                      </div>
                                    ))
                                  ) : (
                                    <p
                                      className="text-xs"
                                      style={{ color: colors.textSecondary }}
                                    >
                                      <div className="flex items-center justify-center h-full">
                                        <Spin size="large" />
                                      </div>
                                    </p>
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })}

                        {/* PAGINATION */}
                        {/* PAGINATION */}
                        {totalPages > 1 && (
                          <div className="flex gap-2 mt-4 flex-wrap items-center justify-end">
                            {/* Previous */}
                            <button
                              disabled={page === 1}
                              onClick={() =>
                                setCurrentPage((prev) => ({
                                  ...prev,
                                  [type]: page - 1,
                                }))
                              }
                              className="px-3 py-1 rounded disabled:opacity-40"
                              style={{
                                background: colors.rowAlt1,
                                color: colors.text,
                              }}
                            >
                              {"<"}
                            </button>

                            {/* Page Numbers With Ellipsis */}
                            {getPaginationRange(page, totalPages).map(
                              (item, index) =>
                                item === "..." ? (
                                  <span
                                    key={index}
                                    className="px-2"
                                    style={{ color: colors.textSecondary }}
                                  >
                                    ...
                                  </span>
                                ) : (
                                  <button
                                    key={index}
                                    onClick={() =>
                                      setCurrentPage((prev) => ({
                                        ...prev,
                                        [type]: item,
                                      }))
                                    }
                                    className="px-3 py-1 rounded border"
                                    style={{
                                      background:
                                        page === item
                                          ? colors.primary
                                          : colors.rowAlt1,
                                      borderColor: colors.primary,
                                      color:
                                        page === item ? "#fff" : colors.text,
                                    }}
                                  >
                                    {item}
                                  </button>
                                ),
                            )}

                            {/* Next */}
                            <button
                              disabled={page === totalPages}
                              onClick={() =>
                                setCurrentPage((prev) => ({
                                  ...prev,
                                  [type]: page + 1,
                                }))
                              }
                              className="px-3 py-1 rounded disabled:opacity-40"
                              style={{
                                background: colors.rowAlt1,
                                color: colors.text,
                              }}
                            >
                              {">"}
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </motion.div>
      )}

      {/* Leak Rate Content */}
      {activeTab === "leak-rate" && <LeakRate />}

      {activeTab === "leak-rate-water" && <WaterRates />}

      {/* Add Parameter Modal */}
      {showAddParameterModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
          style={{ backgroundColor: colors.modalOverlay }}
          onClick={() => {
            setShowAddParameterModal(false);
            setIsEditMode(false);
            setEditId(null);
            resetParameterForm();
            setParameterErrors({});
          }}
        >
          <motion.div
            className="w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden border max-[767px]:h-[450px] max-[767px]:overflow-y-auto"
            style={{
              background: colors.inputBg, // Adding opacity to the card background
              borderColor: colors.border,
            }}
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="p-6 border-b flex items-center justify-between"
              style={{ borderColor: colors.border }}
            >
              <h2
                className="text-xl font-bold text-transparent bg-clip-text"
                style={{
                  backgroundImage: colors.gradient,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {" "}
                {isEditMode ? "Edit Parameter" : "Add New Parameter"}
              </h2>
              <button
                onClick={() => {
                  setShowAddParameterModal(false);
                  setIsEditMode(false);
                  setEditId(null);
                  resetParameterForm();
                }}
                className="w-8 h-8 flex items-center justify-center rounded-full transition"
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = colors.hoverBg)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
                style={{ color: colors.text }}
              >
                ✕
              </button>
            </div>
            <div className="p-6 space-y-5">
              {["name", "value", "unit", "displayName"].map((field) => (
                <div key={field}>
                  <label
                    className="block font-semibold mb-2 text-sm capitalize"
                    style={{ color: colors.textSecondary }}
                  >
                    {field.replace(/([A-Z])/g, " $1")}
                  </label>
                  <input
                    type="text"
                    value={newParameter[field]}
                    onChange={(e) =>
                      setNewParameter({
                        ...newParameter,
                        [field]: e.target.value,
                      })
                    }
                    readOnly={isEditMode && field === "name"}
                    className="w-full px-4 py-3 rounded-lg border outline-none transition"
                    style={{
                      background: parameterErrors[field]
                        ? colors.rowAlt2
                        : colors.inputBg,
                      borderColor: parameterErrors[field]
                        ? colors.primary
                        : colors.border,
                      color: colors.text,
                      cursor: parameterErrors[field] ? "not-allowed" : "text",
                    }}
                    onFocus={(e) =>
                      (e.target.style.borderColor = colors.primary)
                    }
                    onBlur={(e) =>
                      (e.target.style.borderColor = parameterErrors[field]
                        ? colors.primary
                        : colors.border)
                    }
                  />

                  {parameterErrors[field] && (
                    <p className="text-red-400 text-xs mt-1">
                      {parameterErrors[field]}
                    </p>
                  )}
                </div>
              ))}
              <div>
                <label
                  className="block font-semibold mb-3 text-sm"
                  style={{ color: colors.textSecondary }}
                >
                  Status
                </label>
                <button
                  onClick={() =>
                    setNewParameter({
                      ...newParameter,
                      status: !newParameter.status,
                    })
                  }
                  className="relative inline-flex h-8 w-14 items-center rounded-full transition-colors"
                  style={{
                    background: newParameter.status
                      ? colors.gradient
                      : colors.border,
                  }}
                >
                  <span
                    className={`inline-block h-6 w-6 transform rounded-full bg-white shadow-lg transition-transform ${
                      newParameter.status ? "translate-x-7" : "translate-x-1"
                    }`}
                  />
                </button>
              </div>
              {/* <button className="w-full py-3.5 rounded-lg bg-linear-to-r from-[#00b8f1] to-[#0060f1] text-white font-semibold hover:shadow-xl transition-all">Submit</button> */}
              <button
                onClick={handleCreate}
                className="w-full py-3.5 rounded-lg font-semibold transition-all"
                style={{
                  background: colors.gradient,
                  color: "#fff",
                }}
              >
                Submit
              </button>
            </div>
          </motion.div>
        </div>
      )}

      {showDeleteModal && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm"
          style={{ backgroundColor: colors.modalOverlay }}
        >
          <div
            className="rounded-xl w-[400px] p-6 relative shadow-xl border"
            style={{
              background: colors.cardBg,
              borderColor: colors.border,
            }}
          >
            {/* Close button */}
            <button
              onClick={() => setShowDeleteModal(false)}
              className="absolute top-3 right-3 text-lg transition"
              style={{ color: colors.textSecondary }}
              onMouseEnter={(e) => (e.currentTarget.style.color = colors.text)}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = colors.textSecondary)
              }
            >
              ✕
            </button>

            <h3
              className="text-lg font-semibold mb-6"
              style={{ color: colors.text }}
            >
              Are you sure you want to permanently remove this item?
            </h3>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 rounded-lg transition"
                style={{
                  background: colors.rowAlt2,
                  color: colors.text,
                  border: `1px solid ${colors.border}`,
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = colors.hoverBg)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = colors.rowAlt2)
                }
              >
                Cancel
              </button>

              <button
                onClick={handleDelete}
                className="px-4 py-2 rounded-lg text-white transition"
                style={{
                  background: colors.gradient,
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* User Registration Modal */}
      {showUserRegistrationModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
          style={{ backgroundColor: colors.modalOverlay }}
          // onClick={() => {
          //   setShowUserRegistrationModal(false);
          //   resetUserForm();
          // }}
        >
          <motion.div
            className="w-full max-w-lg backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden border max-[767px]:h-[450px] max-[767px]:overflow-y-auto"
            style={{
              background: colors.inputBg, // Adding opacity to the card background
              borderColor: colors.border,
            }}
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="p-6 border-b flex justify-between items-center"
              style={{ borderColor: colors.border }}
            >
              <h2
                className="text-xl font-bold text-transparent bg-clip-text"
                style={{
                  backgroundImage: colors.gradient,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                User Registration
              </h2>

              <button
                onClick={() => {
                  setShowUserRegistrationModal(false);
                  resetUserForm();
                }}
                className="text-xl transition"
                style={{ color: colors.textSecondary }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = colors.text)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = colors.textSecondary)
                }
              >
                ✕
              </button>
            </div>
            <div className="p-6 space-y-5 overflow-auto h-[690px]">
              {["firstName", "lastName", "email", "password"].map((field) => (
                <div key={field}>
                  <label
                    className="block font-semibold mb-2 text-sm capitalize"
                    style={{ color: colors.textSecondary }}
                  >
                    {field.replace(/([A-Z])/g, " $1")}
                  </label>

                  <input
                    type={field === "password" ? "password" : "text"}
                    autoComplete={field === "password" ? "new-password" : "off"}
                    value={newUser[field]}
                    onChange={(e) => {
                      const value = e.target.value;

                      setNewUser({ ...newUser, [field]: value });
                      setUserErrors({ ...userErrors, [field]: "" });

                      if (field === "password") {
                        const score = calculatePasswordStrength(value);
                        setNewUserPasswordScore(score);
                      }
                    }}
                    className="w-full px-4 py-3 rounded-lg border outline-none transition"
                    style={{
                      background: colors.inputBg,
                      borderColor: userErrors[field]
                        ? colors.danger
                        : colors.border,
                      color: colors.text,
                    }}
                    onFocus={(e) =>
                      (e.target.style.borderColor = colors.primary)
                    }
                    onBlur={(e) =>
                      (e.target.style.borderColor = userErrors[field]
                        ? colors.danger
                        : colors.border)
                    }
                  />

                  {userErrors[field] && (
                    <p className="text-red-500 text-xs mt-1">
                      {userErrors[field]}
                    </p>
                  )}
                </div>
              ))}
              {newUser.password.length > 0 && (
                <>
                  {/* Strength Bar */}
                  <div className="w-full bg-gray-200 rounded h-2 mt-3">
                    <div
                      className={`h-2 rounded transition-all ${
                        newUserPasswordScore <= 2
                          ? "bg-red-500"
                          : newUserPasswordScore === 3
                            ? "bg-yellow-500"
                            : "bg-green-500"
                      }`}
                      style={{ width: `${(newUserPasswordScore / 5) * 100}%` }}
                    />
                  </div>

                  {/* Strength Text */}
                  <div className="text-sm mt-2 text-center font-medium text-white">
                    {["Very Weak", "Weak", "Good", "Strong", "Very Strong"][
                      newUserPasswordScore - 1
                    ] || ""}
                  </div>

                  {/* Requirements */}
                  <div className="text-xs text-red-500 mt-3">
                    <p>Password Requirements:</p>
                    <ul className="list-disc ml-5">
                      <li>Minimum 8 characters</li>
                      <li>At least one uppercase letter</li>
                      <li>At least one number</li>
                      <li>At least one special character</li>
                      <li>No spaces</li>
                    </ul>
                  </div>
                </>
              )}
              <div className="relative">
                <label className="block text-[#BDB9B5] font-semibold mb-2 text-sm">
                  User Type
                </label>
                <select
                  value={newUser.userType}
                  onChange={(e) =>
                    setNewUser({ ...newUser, userType: e.target.value })
                  }
                  className="w-full px-4 py-3 rounded-lg border outline-none appearance-none cursor-pointer"
                  style={{
                    background: colors.inputBg,
                    borderColor: colors.border,
                    color: colors.text,
                  }}
                  onFocus={(e) => (e.target.style.borderColor = colors.primary)}
                  onBlur={(e) => (e.target.style.borderColor = colors.border)}
                >
                  <option value="">Please Select</option>

                  {userTypeOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
                <ChevronDown
                  style={{ color: colors.textSecondary }}
                  className="absolute right-4 top-[70%] -translate-y-1/2 w-4 h-4 pointer-events-none"
                />
                {userErrors.userType && (
                  <p className="text-red-500 text-xs mt-1">
                    {userErrors.userType}
                  </p>
                )}
              </div>
              {/* District Selection */}
              <div>
                <label className="block text-[#BDB9B5] font-semibold mb-3 text-sm">
                  District Selection
                </label>

                <div className="flex gap-6">
                  {userDistricts.map((dist) => (
                    <label
                      key={dist.district_name}
                      className="flex items-center gap-2 cursor-pointer"
                      style={{ color: colors.text }}
                    >
                      <input
                        type="checkbox"
                        checked={newUser.districts.includes(dist.district_name)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setNewUser({
                              ...newUser,
                              districts: [
                                ...newUser.districts,
                                dist.district_name,
                              ],
                            });
                          } else {
                            setNewUser({
                              ...newUser,
                              districts: newUser.districts.filter(
                                (d) => d !== dist.district_name,
                              ),
                            });
                          }
                        }}
                        className="w-4 h-4"
                        style={{
                          accentColor: colors.primary,
                          border: colors.border,
                        }}
                      />

                      {/* Show display name */}
                      {dist.district_display_name}
                    </label>
                  ))}
                </div>
                {userErrors.districts && (
                  <p className="text-red-500 text-xs mt-2">
                    {userErrors.districts}
                  </p>
                )}
              </div>
              {userErrors.apiError && (
                <p className="text-red-500 text-sm text-center">
                  {userErrors.apiError}
                </p>
              )}
              <button
                onClick={handleUserSignup}
                className="w-full py-3.5 rounded-lg text-white font-semibold transition-all"
                style={{
                  background: colors.gradient,
                }}
              >
                Submit
              </button>
            </div>
          </motion.div>
        </div>
      )}

      {showEditUserModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm "
          style={{ backgroundColor: colors.modalOverlay }}
        >
          <div
            className="w-full max-w-lg rounded-xl p-6 border max-[767px]:h-[450px] max-[767px]:overflow-y-auto"
            style={{
              background: colors.cardBg,
              borderColor: colors.border,
            }}
          >
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold" style={{ color: colors.text }}>
                Edit User
              </h2>
              <button
                onClick={() => {
                  setShowEditUserModal(false);
                }}
                className="text-xl transition"
                style={{ color: colors.textSecondary }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = colors.text)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = colors.textSecondary)
                }
              >
                ✕
              </button>
            </div>

            {["firstName", "lastName", "email"].map((field) => (
              <div key={field} className="mb-4">
                <label
                  className="text-sm capitalize"
                  style={{ color: colors.textSecondary }}
                >
                  {field}
                </label>

                <input
                  value={editUserData[field] || ""}
                  onChange={(e) => {
                    setEditUserData({
                      ...editUserData,
                      [field]: e.target.value,
                    });

                    // Clear field error when typing
                    setEditUserErrors({
                      ...editUserErrors,
                      [field]: "",
                    });
                  }}
                  className="w-full mt-1 px-4 py-2 border rounded outline-none transition"
                  style={{
                    background: colors.inputBg,
                    borderColor: editUserErrors[field]
                      ? colors.danger
                      : colors.border,
                    color: colors.text,
                  }}
                  onFocus={(e) => (e.target.style.borderColor = colors.primary)}
                  onBlur={(e) =>
                    (e.target.style.borderColor = editUserErrors[field]
                      ? colors.danger
                      : colors.border)
                  }
                />

                {editUserErrors[field] && (
                  <p className="text-xs mt-1" style={{ color: colors.danger }}>
                    {editUserErrors[field]}
                  </p>
                )}
              </div>
            ))}

            {/* User Type */}
            <label
              className="block font-semibold mb-2 text-sm"
              style={{ color: colors.textSecondary }}
            >
              User Type
            </label>
            <select
              value={editUserData.userType ?? ""}
              onChange={(e) =>
                setEditUserData((prev) => ({
                  ...prev,
                  userType: e.target.value,
                }))
              }
              className="w-full mb-4 px-4 py-2 border rounded outline-none"
              style={{
                background: colors.inputBg,
                borderColor: colors.border,
                color: colors.text,
              }}
              onFocus={(e) => (e.target.style.borderColor = colors.primary)}
              onBlur={(e) => (e.target.style.borderColor = colors.border)}
            >
              <option value="">Please Select</option>
              <option value="SA">Super Admin</option>
              <option value="A">Admin</option>
              <option value="U">User</option>
            </select>
            {editUserErrors.userType && (
              <p className="text-xs mt-1" style={{ color: colors.danger }}>
                {editUserErrors.userType}
              </p>
            )}
            <div>
              <label
                className="block font-semibold mb-3 text-sm"
                style={{ color: colors.textSecondary }}
              >
                District Selection
              </label>

              <div className="flex gap-6">
                {[
                  { label: "GPMD", value: "GPMD" },
                  { label: "FB-151", value: "FB151" },
                ].map((dist) => (
                  <label
                    key={dist.value}
                    className="flex items-center gap-2 cursor-pointer"
                    style={{ color: colors.text }}
                  >
                    <input
                      type="checkbox"
                      checked={editUserData.districts?.includes(dist.value)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setEditUserData({
                            ...editUserData,
                            districts: [
                              ...(editUserData.districts || []),
                              dist.value,
                            ],
                          });
                        } else {
                          setEditUserData({
                            ...editUserData,
                            districts: editUserData.districts.filter(
                              (d) => d !== dist.value,
                            ),
                          });
                        }
                      }}
                      className="w-4 h-4"
                      style={{
                        accentColor: colors.primary,
                        border: colors.border,
                      }}
                    />
                    {dist.label}
                  </label>
                ))}
              </div>
              {editUserErrors.districts && (
                <p className="text-xs mt-2" style={{ color: colors.danger }}>
                  {editUserErrors.districts}
                </p>
              )}
            </div>

            {/* Active Switch */}
            <div className="my-4">
              <label
                className="block font-semibold mb-3 text-sm"
                style={{ color: colors.textSecondary }}
              >
                Active
              </label>

              <button
                onClick={() =>
                  setEditUserData({
                    ...editUserData,
                    isActive: !editUserData.isActive,
                  })
                }
                className="relative inline-flex h-8 w-14 items-center rounded-full transition-all duration-300"
                style={{
                  background: editUserData.isActive
                    ? colors.gradient
                    : colors.border,
                }}
              >
                <span
                  className={`inline-block h-6 w-6 transform rounded-full shadow-lg transition-transform duration-300 ${
                    editUserData.isActive ? "translate-x-7" : "translate-x-1"
                  }`}
                  style={{ background: colors.innerCardBg }}
                />
              </button>
            </div>

            {/* Password Reset Link */}
            <div className="flex justify-between items-center mb-6">
              <div></div>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setShowPasswordModal(true);
                }}
                className="text-sm"
                style={{ color: colors.primary }}
              >
                Password Reset
              </a>
            </div>
            {editUserErrors.apiError && (
              <p
                className="text-sm text-center mb-3"
                style={{ color: colors.danger }}
              >
                {editUserErrors.apiError}
              </p>
            )}
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowEditUserModal(false)}
                className="px-4 py-2 rounded"
                style={{
                  background: colors.rowAlt2,
                  color: colors.text,
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleUserEdit}
                className="px-4 py-2 rounded text-white"
                style={{ background: colors.gradient }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteUserModal && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm"
          style={{ backgroundColor: colors.modalOverlay }}
        >
          <div
            className="rounded-xl p-6 w-96 border"
            style={{
              background: colors.cardBg,
              borderColor: colors.border,
            }}
          >
            <h3
              className="text-lg font-semibold mb-4"
              style={{ color: colors.text }}
            >
              Confirm Delete
            </h3>

            <p className="text-sm mb-6" style={{ color: colors.textSecondary }}>
              Are you sure you want to delete this user?
            </p>

            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 rounded-lg border transition"
                style={{
                  borderColor: colors.border,
                  color: colors.textSecondary,
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = colors.hoverBg)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
                onClick={() => {
                  setShowDeleteUserModal(false);
                  setDeleteUserId(null);
                }}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 rounded-lg text-white transition"
                style={{ background: colors.danger }}
                onClick={confirmUserDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {showPasswordModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm"
          style={{ backgroundColor: colors.modalOverlay }}
        >
          <div
            className="w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden border p-6 relative max-[767px]:h-[450px] max-[767px]:overflow-y-auto"
            style={{
              background: colors.cardBg,
              borderColor: colors.border,
            }}
          >
            <button
              onClick={() => setShowPasswordModal(false)}
              className="absolute right-4 top-4 text-xl transition"
              style={{ color: colors.textSecondary }}
              onMouseEnter={(e) => (e.currentTarget.style.color = colors.text)}
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = colors.textSecondary)
              }
            >
              ✕
            </button>

            <h3
              className="text-lg font-semibold mb-4"
              style={{ color: colors.text }}
            >
              Reset Password
            </h3>
            <div className="mb-6">
              <label className="font-medium" style={{ color: colors.text }}>
                {" "}
                New Password
              </label>

              <input
                type="password"
                value={passwordData.newPassword}
                onChange={(e) => {
                  const value = e.target.value;

                  handlePasswordChange(e);
                  setIsTypingPassword(value.length > 0);
                }}
                className="w-full mt-2 px-4 py-3 rounded-lg border outline-none transition"
                style={{
                  background: colors.inputBg,
                  borderColor: colors.border,
                  color: colors.text,
                }}
                onFocus={(e) => (e.target.style.borderColor = colors.primary)}
                onBlur={(e) => (e.target.style.borderColor = colors.border)}
              />

              {/* Show only when typing */}
              {isTypingPassword && (
                <>
                  {/* Thin Strength Bar */}
                  <div className="mt-4">
                    <div
                      className="h-1.5 w-full rounded-full overflow-hidden"
                      style={{ background: colors.rowAlt2 }}
                    >
                      <div
                        className={`h-full transition-all duration-300 ${
                          passwordScore <= 1
                            ? "bg-red-500 w-[20%]"
                            : passwordScore === 2
                              ? "bg-orange-400 w-[40%]"
                              : passwordScore === 3
                                ? "bg-yellow-400 w-[60%]"
                                : passwordScore === 4
                                  ? "bg-blue-400 w-[80%]"
                                  : "bg-green-500 w-full"
                        }`}
                      />
                    </div>

                    <p
                      className="text-sm mt-2"
                      style={{ color: colors.textSecondary }}
                    >
                      Strength :
                      <span
                        className={`ml-1 font-medium ${
                          passwordScore <= 1
                            ? "text-red-500"
                            : passwordScore === 2
                              ? "text-orange-400"
                              : passwordScore === 3
                                ? "text-yellow-400"
                                : passwordScore === 4
                                  ? "text-blue-400"
                                  : "text-green-500"
                        }`}
                      >
                        {passwordScore <= 1
                          ? "Very Weak"
                          : passwordScore === 2
                            ? "Weak"
                            : passwordScore === 3
                              ? "Medium"
                              : passwordScore === 4
                                ? "Strong"
                                : "Very Strong"}
                      </span>
                    </p>
                  </div>

                  {/* Requirements */}
                  <div className="mt-3 text-sm space-y-1">
                    <p style={{ color: colors.danger }} className="font-medium">
                      Password Requirements:
                    </p>

                    <p
                      className={
                        passwordData.newPassword.length >= 8
                          ? "text-green-400"
                          : "text-red-400"
                      }
                    >
                      Minimum Length: 8 characters
                    </p>

                    <p
                      className={
                        /[A-Z]/.test(passwordData.newPassword)
                          ? "text-green-400"
                          : "text-red-400"
                      }
                    >
                      One uppercase letter (A-Z)
                    </p>

                    <p
                      className={
                        /[0-9]/.test(passwordData.newPassword)
                          ? "text-green-400"
                          : "text-red-400"
                      }
                    >
                      One number (0-9)
                    </p>

                    <p
                      className={
                        /[!@#$%^&*]/.test(passwordData.newPassword)
                          ? "text-green-400"
                          : "text-red-400"
                      }
                    >
                      One special character
                    </p>

                    <p
                      className={
                        !/\s/.test(passwordData.newPassword)
                          ? "text-green-400"
                          : "text-red-400"
                      }
                    >
                      No spaces
                    </p>
                  </div>
                </>
              )}
            </div>

            <div className="mb-6">
              <label className="font-medium" style={{ color: colors.text }}>
                Confirm Password
              </label>

              <input
                type="password"
                value={passwordData.confirmPassword}
                onChange={handleConfirmChange}
                className="w-full mt-2 px-4 py-3 rounded-lg border outline-none"
                style={{
                  background: colors.inputBg,
                  borderColor: colors.border,
                  color: colors.text,
                }}
                onFocus={(e) => (e.target.style.borderColor = colors.primary)}
                onBlur={(e) => (e.target.style.borderColor = colors.border)}
              />

              {confirmFeedback && (
                <p
                  className={`text-sm mt-2 ${
                    confirmFeedback === "Password matched"
                      ? "text-green-400"
                      : "text-red-500"
                  }`}
                >
                  {confirmFeedback}
                </p>
              )}
            </div>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowPasswordModal(false)}
                className="px-4 py-2 rounded"
                style={{
                  background: colors.rowAlt2,
                  color: colors.text,
                }}
              >
                Cancel
              </button>
              <button
                onClick={handlePasswordReset}
                className="px-4 py-2 rounded text-white"
                style={{ background: colors.gradient }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {/* username edit -  accounts tab */}
      {showEditUserNameModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm"
          style={{ backgroundColor: colors.modalOverlay }}
        >
          <div
            className="w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden border p-6 relative max-[767px]:h-[450px] max-[767px]:overflow-y-auto"
            style={{
              background: colors.cardBg,
              borderColor: colors.border,
            }}
          >
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold" style={{ color: colors.text }}>
                Edit Override Name
              </h2>
              <button
                onClick={() => {
                  setShowEditUserNameModal(false);
                }}
                className="text-xl transition"
                style={{ color: colors.textSecondary }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = colors.text)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = colors.textSecondary)
                }
              >
                ✕
              </button>
            </div>
            <div className="mb-6">
              <label
                className="text-sm capitalize"
                style={{ color: colors.textSecondary }}
              >
                Override Name
              </label>
              <input
                type="text"
                value={editUserName}
                onChange={(e) => setEditUserName(e.target.value)}
                className="w-full mt-2 px-4 py-3 rounded-lg border outline-none"
                style={{
                  background: colors.inputBg,
                  borderColor: colors.border,
                  color: colors.text,
                }}
              />
            </div>
            <div className="flex justify-end gap-3 mt-4">
              <button
                onClick={() => setShowEditUserNameModal(false)}
                className="px-4 py-2 rounded"
                style={{
                  background: colors.rowAlt2,
                  color: colors.text,
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleUserNameUpdate}
                className="px-4 py-2 rounded text-white"
                style={{ background: colors.gradient }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default Listuser;
